import React from 'react';
import PropTypes from 'prop-types';

import TranslationProvider, { getTranslation } from '../../providers/TranslationProvider';
import Form from './Form';
import Label from './Label';
import FormErrorInline from './FormErrorInline';
import { EmailInput, PasswordInput } from '../Input';
import { SubmitButton } from '../Button';
import AriaLiveRegion from '../AriaLiveRegion';

import './Form.scss';

const LoginForm = (props) => {
  const {
    onSubmit, cta, email, error,
  } = props;

  return (
    <div className="LoginForm">
      <Form
        name="login_form"
        onSubmit={onSubmit}
        error={error}
      >
        {({
          onChange, errorData, errorKeys, processing, msg,
        }) => (
          <div>
            <AriaLiveRegion
              id="LoginForm__status"
            >
              {processing ? 'Loading' : ''}
            </AriaLiveRegion>
            <Label forInput="email" required>
              <TranslationProvider
                translationKey="email_address"
              >
                Email Address
              </TranslationProvider>
            </Label>
            <EmailInput
              ariaRequired
              onChange={onChange}
              errors={errorKeys}
              value={email}
            />
            {errorData
              && errorData.em_address
              && <FormErrorInline>{errorData.em_address}</FormErrorInline>}
            <Label forInput="password" required>
              <TranslationProvider
                translationKey="onboarding.password"
              >
                Password
              </TranslationProvider>
            </Label>
            <PasswordInput
              ariaLabel={getTranslation({ translationKey: 'password', fallback: 'Password' })}
              type="current"
              ariaRequired
              confirmPassword={false}
              onChange={onChange}
              errors={errorKeys}
            />
            {errorData
              && errorData.password
              && <FormErrorInline>{errorData.password}</FormErrorInline>}
            <TranslationProvider
              translationKey="onboarding.continue"
            >
              <SubmitButton
                lg
                processing={processing}
              >
                {cta}
              </SubmitButton>
            </TranslationProvider>
            {msg
              && <span>{msg}</span>}
          </div>
        )}
      </Form>
    </div>
  );
};

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  cta: PropTypes.string,
  email: PropTypes.string,
  error: PropTypes.shape({
    serverError: PropTypes.bool,
    msg: PropTypes.string,
    keys: PropTypes.arrayOf(PropTypes.string),
  }),
};

LoginForm.defaultProps = {
  cta: 'Continue',
  email: '',
  error: {
    serverError: false,
    msg: '',
    keys: [],
  },
};

export default LoginForm;
